import { render, staticRenderFns } from "./MTACdetail.vue?vue&type=template&id=8ebb6008&scoped=true"
import script from "./MTACdetail.vue?vue&type=script&lang=js"
export * from "./MTACdetail.vue?vue&type=script&lang=js"
import style0 from "./MTACdetail.vue?vue&type=style&index=0&id=8ebb6008&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebb6008",
  null
  
)

export default component.exports